module.exports = __webpack_public_path__ + "static/RootSans-1Thin-153f3e2970740973a1d2535bb90c01b5.woff2";